// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"3a1daccdc95243e9","485":"8fee184051ac9fb5","589":"c09cbc9e6a4f25db","670":"f506c8284efc4082","778":"23b4cf43541efb88","870":"be20c7e188898548","873":"8681f613aa7a421e","915":"382b5f380b3bf06e"}[chunkId] + ".js";
};